import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

export default class extends Controller {
  static targets = ["toggle"]

  focus() {
    this.element.querySelector('input[type="search"]').focus()
  }

  close() {
    Dropdown.getInstance(this.toggleTarget)?.hide()
  }

  disconnect() {
    this.close()
    Dropdown.getInstance(this.toggleTarget)?.dispose()
  }
}
